import { createSelector } from 'reselect';
import { RootState } from '../reducers/root.reducer';

export const getOperators = createSelector(
	(state: RootState) => state.operatorList.operators,
	operators => operators,
);

export const getOperatorsForFilter = createSelector(
	(state: RootState) => state.operatorList.operators,
	operators => {
		return [];
	},
);

export const getOperatorsMap = createSelector(
    (state: RootState) => state.operatorList.operators,
    operators => {
        const operatorsMap: { [key: number]: object } = {};
        operators.forEach(operator => {
            operatorsMap[operator.id] = operator;
        });

        return operatorsMap;
    },
);

export const getOperatorIdList = createSelector(
    (state: RootState) => state.operatorList.operators,
    operators => operators.map(operator => operator.id),
);